export default __webpack_public_path__ + "static/Peter-ce46b50790ef49d39da2ecfe38c98fe7.png";